/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  Bundler3,
  Bundler3Interface,
} from "../../../contracts/test/Bundler3";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "skipRevert",
            type: "bool",
          },
          {
            internalType: "bytes32",
            name: "callbackHash",
            type: "bytes32",
          },
        ],
        internalType: "struct Call[]",
        name: "bundle",
        type: "tuple[]",
      },
    ],
    name: "multicall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561000f575f80fd5b5060d08061001c5f395ff3fe608060405260043610601b575f3560e01c8063374f435d14601f575b5f80fd5b602e602a3660046030565b5050565b005b5f80602083850312156040575f80fd5b823567ffffffffffffffff808211156056575f80fd5b818501915085601f8301126068575f80fd5b8135818111156075575f80fd5b8660208260051b85010111156088575f80fd5b6020929092019691955090935050505056fea26469706673582212207d7f15a537f6bed754bfa36fda9ab90a2d5484012220df94166cde7b67b15d9364736f6c63430008150033";

type Bundler3ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Bundler3ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Bundler3__factory extends ContractFactory {
  constructor(...args: Bundler3ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      Bundler3 & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Bundler3__factory {
    return super.connect(runner) as Bundler3__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Bundler3Interface {
    return new Interface(_abi) as Bundler3Interface;
  }
  static connect(address: string, runner?: ContractRunner | null): Bundler3 {
    return new Contract(address, _abi, runner) as unknown as Bundler3;
  }
}
